export const titleCase = (value) => {
    if (!value || value.length === 0)
        return '';
    let words = value.replace(/_/g, ' ').split(' ');
    for (let i in words) {
        if (!words[i])
            continue;
        words[i] = words[i][0].toUpperCase() + words[i].substr(1).toLowerCase();
    }
    return words.join(' ');
};
